// Authored terminal alternatives stay in source; each run selects one path.
export function normalizeEndingBranch(input, cues, characters) {
  if (input == null) return undefined;
  const fail = () => { throw Error('Ending branches must name one actor choice and contiguous terminal cue ranges.'); };
  const indices = new Map(cues.map((cue, index) => [cue.id, index]));
  const choice = indices.get(input.choiceCueId), owner = characters.find(c => c.id === input.characterId);
  if (!owner || !Number.isInteger(choice) || cues[choice].type !== 'ending' || cues[choice].characterId !== owner.id
    || !Array.isArray(input.paths) || input.paths.length < 2 || input.paths.length > 5 || indices.size !== cues.length) fail();
  let next = choice + 1; const ids = new Set();
  const paths = input.paths.map(p => {
    if (!p || !/^[a-z][a-z0-9-]{0,30}$/.test(p.id) || ids.has(p.id) || typeof p.label !== 'string' || !p.label.trim() || p.label.length > 100) fail();
    ids.add(p.id); const start = indices.get(p.startCueId), end = indices.get(p.endCueId);
    if (start !== next || !Number.isInteger(end) || end < start) fail();
    next = end + 1; return { id: p.id, label: p.label.trim(), startCueId: p.startCueId, endCueId: p.endCueId };
  });
  if (next !== cues.length) fail();
  return { choiceCueId: input.choiceCueId, characterId: owner.id, paths };
}
export function branchRange(scenario, choice) {
  const path = scenario.endingBranch?.paths.find(p => p.id === choice);
  return path ? {start:scenario.cues.findIndex(c => c.id === path.startCueId),end:scenario.cues.findIndex(c => c.id === path.endCueId)} : null;
}
export function nextRehearsalCueIndex(room) {
  const branch = room.scenario.endingBranch;
  if (!branch) return room.cueIndex + 1 >= room.scenario.cues.length ? -1 : room.cueIndex + 1;
  const choice = room.scenario.cues.findIndex(c => c.id === branch.choiceCueId);
  if (room.cueIndex < choice) return room.cueIndex + 1;
  const range = branchRange(room.scenario, room.endingChoice);
  if (!range) return null;
  if (room.cueIndex === choice) return range.start;
  if (room.cueIndex < range.start || room.cueIndex > range.end) throw Error('That cue is outside the chosen ending.');
  return room.cueIndex === range.end ? -1 : room.cueIndex + 1;
}
export function previousRehearsalCueIndex(room) {
  const range = branchRange(room.scenario, room.endingChoice);
  return range && room.cueIndex === range.start
    ? room.scenario.cues.findIndex(c => c.id === room.scenario.endingBranch.choiceCueId) : Math.max(0, room.cueIndex - 1);
}
export function assertEndingDestination(room, index) {
  if (!Number.isInteger(index) || index < 0 || index >= room.scenario.cues.length) throw Error('Choose a valid cue.');
  const branch = room.scenario.endingBranch; if (!branch) return;
  const choice = room.scenario.cues.findIndex(c => c.id === branch.choiceCueId);
  if (index <= choice) return;
  const range = branchRange(room.scenario, room.endingChoice);
  if (!range || index < range.start || index > range.end) throw Error('Choose the ending at its actor choice before entering that path.');
}
export function selectEnding(room, id, characterId) {
  const branch = room.scenario.endingBranch;
  if (!branch || room.scenario.cues[room.cueIndex]?.id !== branch.choiceCueId || characterId !== branch.characterId) throw Error('Only the assigned actor may choose at the ending cue.');
  if (!branch.paths.some(p => p.id === id)) throw Error('Choose one of the authored endings.');
  room.endingChoice = id;
}
export function isCueOnSelectedPath(room, index) {
  const branch = room.scenario.endingBranch; if (!branch) return true;
  const choice = room.scenario.cues.findIndex(c => c.id === branch.choiceCueId);
  if (index <= choice) return true;
  const range = branchRange(room.scenario, room.endingChoice);
  return Boolean(range && index >= range.start && index <= range.end);
}
